import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

import { BodyHtmlComponent } from '../body-html/body-html.component';
import { AppLabelBadge, LabelBadgeColor } from '../../uikit/label-badge/label-badge.component';

@Component({
  selector: 'app-content-block',
  imports: [AppLabelBadge, BodyHtmlComponent],
  templateUrl: './content-block.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './content-block.component.scss',
})
export class ContentBlockComponent {
  @Input() public label: string = '';
  @Input() public heading: string = '';
  @Input() public description: string = '';
  @Input() public imageUrl: string = '';
  @Input() public imageAlt: string = '';
  @Input() public imagePosition: 'left' | 'right' = 'left';
  private _labelColor: LabelBadgeColor = 'purple';

  @Input()
  public set labelColor(value: LabelBadgeColor | null | '') {
    this._labelColor = value || 'purple';
  }

  public get labelColor(): LabelBadgeColor {
    return this._labelColor;
  }
}
